/**
 * 동영상
 */
import { Fragment } from 'react';
import { useOption } from '@hooks/useOption';
import { CUR_NETWORK, NCTV_DOMAIN, SERVICE_ALIAS } from '@constants/service';
import { setTimeFormat, setYMDDateFormat } from '@utils/index';
import type { INctv, ISetNctv, l10nType } from '@type/index';

export const setNctvItem = (item: INctv, serviceAlias: string): ISetNctv | null => {
  if (!item || typeof item !== 'object') {
    return null;
  }

  return {
    ...item,
    videoUrl: `${NCTV_DOMAIN[CUR_NETWORK]}/view?tv=${serviceAlias}&id=${item?.videoId}`,
    thumbnailUrl: item?.videoThumbnail || item?.channelThumbnail,
    target: '_self',
  };
};

// AION
const AionVideo = ({ item }: { item: ISetNctv }) => {
  const { videoUrl, target, thumbnailUrl, playtime, title, content, channelName, createdDatetime } = item || {};

  return (
    <div className={`search-item-content ${SERVICE_ALIAS.AION}`}>
      <div className="search-item-thumbnail">
        <a href={videoUrl} target={target}>
          <div className="thumb-wrap">
            {thumbnailUrl ? <img src={thumbnailUrl} alt="" /> : <Fragment />}
            <span className="mask"></span>
            <span className="play-icon"></span>
            <span className="play-time">{setTimeFormat(playtime)}</span>
          </div>
        </a>
      </div>
      <div className="search-item-article">
        <div className="search-item-title">
          <a href={videoUrl} target={target} dangerouslySetInnerHTML={{ __html: title }}></a>
        </div>
        <div className="search-item-summary">
          <a href={videoUrl} target={target} dangerouslySetInnerHTML={{ __html: content }}></a>
        </div>
        <div className="search-item-info">
          <span>{channelName}</span>
          <span>{setYMDDateFormat(createdDatetime)}</span>
        </div>
      </div>
    </div>
  );
};

// BNS
const BnsVideo = ({ item }: { item: ISetNctv }) => {
  const { videoUrl, target, thumbnailUrl, playtime, title, content, channelName, createdDatetime } = item || {};

  return (
    <div className={`search-item-content ${SERVICE_ALIAS.BNS}`}>
      <div className="search-item-thumbnail">
        <a href={videoUrl} target={target}>
          <div className="thumb-wrap">
            {thumbnailUrl ? <img src={thumbnailUrl} alt="" /> : <Fragment />}
            <span className="play-icon"></span>
          </div>
        </a>
      </div>
      <div className="search-item-article">
        <div className="search-item-title">
          <a href={videoUrl} target={target} dangerouslySetInnerHTML={{ __html: title }}></a>
        </div>
        <div className="search-item-summary">
          <a href={videoUrl} target={target} dangerouslySetInnerHTML={{ __html: content }}></a>
        </div>
        <div className="search-item-info">
          <span>{channelName}</span>
          <span>{setTimeFormat(playtime)}</span>
          <span>{setYMDDateFormat(createdDatetime)}</span>
        </div>
      </div>
    </div>
  );
};

const NctvArticle = ({ item, l10n }: { item: INctv; l10n: l10nType }) => {
  const { serviceAlias } = useOption();
  const data = setNctvItem(item, serviceAlias);

  if (!data) {
    return <Fragment />;
  }

  return serviceAlias === SERVICE_ALIAS.BNS ? <BnsVideo item={data} /> : <AionVideo item={data} />;
};

export default NctvArticle;
